import { NotificationDefinition } from '../../types'
import { GenericNotificationHeader } from './GenericNotificationHeader'
import { GenericNotificationListItem } from './GenericNotificationListItem'
import { GenericNotificationPreview } from './GenericNotificationPreview'

export const genericNotificationDefinition: NotificationDefinition = {
  listItemContent: GenericNotificationListItem,
  previewHeaderContent: GenericNotificationHeader,
  previewContent: GenericNotificationPreview,
  // "Dismiss" rather than "Done": the agent raised something it couldn't action,
  // so the operator acknowledges it rather than marking work as completed.
  dismissAction: { label: 'Dismiss', variant: 'secondary' }
}
